export default __webpack_public_path__ + "static/berufsreise.guide-f8cd8325285c3f938f1fe1366233653f.jpg";